import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
`;

const Footer = props => (
  <Wrapper {...props} />
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/organisms/Footer/index.js